import React from 'react'

const ItenStockList = () => {
  return (
    <div>ItenStockList</div>
  )
}

export default ItenStockList